import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import OrgLandingPageEditor from '../components/OrgLandingPageEditor'
import { api } from '../lib/api'

export default function OrgLandingPageEditPage() {
  const { orgId } = useParams()
  const orgIdNum = orgId ? parseInt(orgId, 10) : null
  const [orgName, setOrgName] = useState('조직')

  useEffect(() => {
    if (!orgIdNum) return
    api.get(`/orgs/${orgIdNum}`)
      .then((res) => {
        const data = res?.data?.data || res?.data
        if (data?.name) {
          setOrgName(data.name)
        }
      })
      .catch(() => {
        // 조직명 로드 실패는 무시
      })
  }, [orgIdNum])

  if (!orgIdNum || Number.isNaN(orgIdNum)) {
    return <div className="p-8 text-center">잘못된 조직 ID입니다.</div>
  }

  const selectedOrg = { id: orgIdNum, name: orgName }

  return (
    <OrgLandingPageEditor
      orgId={orgIdNum}
      onUpdate={() => {}}
      selectedOrg={selectedOrg}
    />
  )
}
